import SPIRElevel1 from './spireIcons/SPIRElevel1.jpg';
import SPIRElevel2 from './spireIcons/SPIRElevel2.jpg';
import SPIRElevel3 from './spireIcons/SPIRElevel3.jpg';
import SPIRElevel4 from './spireIcons/SPIRElevel4.jpg';
import SPIRElevel5 from './spireIcons/SPIRElevel5.jpg';
import SPIRElevel6 from './spireIcons/SPIRElevel6.jpg';

// stores the image paths for the custom level icons per partner and level
export default {
  'spire': {
    1: SPIRElevel1,
    2: SPIRElevel2,
    3: SPIRElevel3,
    4: SPIRElevel4,
    5: SPIRElevel5,
    6: SPIRElevel6,
  }
}